import { ref, onMounted, onBeforeUnmount } from 'vue'

export function useBreakpoint() {
    const isMobile = ref(false)
    let mediaQuery = null

    const update = (e) => {
        isMobile.value = e.matches
    }

    onMounted(() => {
        mediaQuery = window.matchMedia('(max-width: 767px)')
        isMobile.value = mediaQuery.matches
        mediaQuery.addEventListener('change', update)
    })

    onBeforeUnmount(() => {
        if (mediaQuery) {
            mediaQuery.removeEventListener('change', update)
        }
    })

    return { isMobile }
}
